// L'état des regroupements de feuilles d'un devis (4 novembre 2026) :
// `GET /devis/:id/regroupements`. Les libellés sont dans `feuillesLibelles.js`.
import { useCallback } from 'react';
import { api } from '../../lib/api.js';
import { useResource } from '../../lib/useResource.js';

/** L'état des regroupements d'un devis ; `cle` change quand les pages bougent. */
export default function useRegroupements(devisId, cle) {
  const load = useCallback(() => api.get(`/devis/${devisId}/regroupements`), [devisId]);
  return useResource(load, [devisId, cle]);
}
